import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import Short from 'Components/Format/DateFormat/Short';
import ImageHeading from '../ImageHeading';

const PowerOfAttorney = ({ generalPowerOfAttorney, editLink }) => (
  <td className="power-of-attorneys">
    <ImageHeading className="power-of-attorney">
      Power of Attorney
      {editLink && (<EditButtonLink
        title="Edit Power Of Attorney"
        to={editLink}
      />)}
    </ImageHeading>
    {generalPowerOfAttorney.length > 0 ? (
      generalPowerOfAttorney.map(powerOfAttorney => (
        <div
          className="power-of-attorney item"
          key={`${powerOfAttorney.id}gpoa`}
        >
          <div className="name">{powerOfAttorney.attributes.principal}</div>
          {powerOfAttorney.attributes.dateExecuted !== '' && (
            <div>
              Executed:&nbsp;
              <Short date={powerOfAttorney.attributes.dateExecuted} />
            </div>
          )}
          {powerOfAttorney.attributes.stateExecuted !== '' && (
            <div>
              State:&nbsp;
              {powerOfAttorney.attributes.stateExecuted}
            </div>
          )}
          {powerOfAttorney.attributes.primaryAgent !== '' && (
            <div>
              Primary:&nbsp;
              {powerOfAttorney.attributes.primaryAgent}
            </div>
          )}
          {powerOfAttorney.attributes.successorAgent !== '' && (
            <div>
              Successor:&nbsp;
              {powerOfAttorney.attributes.successorAgent}
            </div>
          )}
        </div>
      ))
    ) : (
      <Fragment>
        <p>No power of attorney.</p>
      </Fragment>
    )}
  </td>
);

PowerOfAttorney.propTypes = {
  generalPowerOfAttorney: PropTypes.array.isRequired,
  editLink: PropTypes.string,
};
PowerOfAttorney.defaultProps = {
  editLink: null,
};

export default PowerOfAttorney;
